import Button from '~/components/Button';
import {
  Link,
  useLoaderData,
  useNavigate,
  useSearchParams,
  type LinksFunction,
  type V2_MetaFunction,
} from '~/remix';
import routeStyles from './_route.module.css';
import { loader } from './_route.server';

export { loader };

export let meta: V2_MetaFunction = ({ data }) => [
  { title: `Sunset Messages - ${data?.title ?? 'Not Found'}` },
];

export let links: LinksFunction = () => [
  { rel: 'stylesheet', href: routeStyles },
];

export default function () {
  const { html, title } = useLoaderData<typeof loader>();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const showAdd = params.get('register') !== 'true';
  const showBackToRegister = params.get('register') === 'true';
  const back = (e: any) => {
    navigate(-1);
    e.preventDefault();
  };

  return (
    <div className="bg-background-dark">
      {title && (
        <div className="sticky top-0 z-20 w-full bg-accent-dark/70 py-2 text-white">
          <h1 className="text-center text-2xl font-bold">{title}</h1>
        </div>
      )}
      <div className="mt-0">
        <div className="prose max-w-none bg-white px-8 pb-8 pt-0 sm:px-16 sm:pb-16 sm:pt-8">
          <div dangerouslySetInnerHTML={{ __html: html }} />
          {showAdd && (
            <div className="not-prose mt-12 text-center">
              <Button
                type="link"
                to="/app/messages/add"
                size="lg"
                variant="primary"
              >
                Create a Message
              </Button>
            </div>
          )}
          {showBackToRegister && (
            <div className="markdown-button-container">
              <Link className="btn btn-primary" to="/register" onClick={back}>
                Continue Registration
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
